import React from 'react';
import { match } from 'variant';
import { Spinner, useAsync } from '@wix/cli-ui-kit';
import { useExtensionDataClient } from '@wix/extensions-data-client';
import { SitePluginWizard } from './SitePluginWizard.js';

export const GenerateSitePlugin: React.FC = () => {
  const { getWidgetPlugins } = useExtensionDataClient();
  const { status } = useAsync(getWidgetPlugins, []);

  return match(status, {
    Error: () => null,
    Loading: () => <Spinner text={'Loading...'} />,
    Success: ({ result }) => <SitePluginWizard widgetPlugins={result} />,
  });
};
